export interface JourneyPathTarget {
  kind: string;
  orderId?: string;
  quoteId?: string;
  leadId?: string;
}

export const ORDERS_DASHBOARD_PATH = "/dashboard/orders";

export function journeyPath(journey: JourneyPathTarget): string {
  if (journey.orderId) return `${ORDERS_DASHBOARD_PATH}/${journey.orderId}`;
  if (journey.kind === "quote" && journey.quoteId) return `${ORDERS_DASHBOARD_PATH}/${journey.quoteId}`;
  if (journey.kind === "request" && journey.leadId) return `${ORDERS_DASHBOARD_PATH}/${journey.leadId}`;
  return ORDERS_DASHBOARD_PATH;
}
